import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux'
import { fetch } from '../../actions'
import { useFetchPost, useFetchPostV2, useSavePost } from '../../components/Hooks/Conexao'
import Mensagens from '../../components/Mensagens';
import Menu from '../Shared/Menu'
import { Button, Icon, Tabs, Input, Checkbox, Modal, Popover } from 'antd';
import ModalDetalhe from '../../components/ModalDetalhe';
import Spinner from '../../components/Spinner/Spinner';
import { SubTitulo, LoadingScreen, IconCheck, IconError } from '../../components/Diversos';
import moment from 'moment'
import Search from 'antd/lib/input/Search';

const { TextArea } = Input;
const culture = new Intl.NumberFormat('pt-BR', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 });

function Content(props) {
    return (<div className="popover-padrao">
        <div onClick={() => props.onClick('det', props.conn, props.id)}>Detalhes</div>
        {/* <div>Editar</div> */}
    </div>)
}

function Func(props) {

    const [dadosDet, setDadosDet] = useState(null)
    const [retorno, setRetorno] = useState(null);
    const [marcados, setMarcados] = useState([]);
    const [textoPesquisa, setTextoPesquisa] = useState(null);

    const [dados, listar, loading, setDados] = useFetchPostV2(props.fetch, '/nf', { modelo: 'contingencias', dados: {txt: textoPesquisa} })
    const [dadosCont, listarCont, loadingCont, setDadosCont] = useFetchPostV2(props.fetch, '/nf', { modelo: 'cont-det', dados: dadosDet })

    const [enviar, enviando] = useSavePost(props.fetch, '/nf/save', { modelo: 'enviarcont', dados: { marcados } },
        (dados) => {
            setRetorno(dados);
            //console.log(dados);
            listar();
        });

    const preEnviar = () => {
        let aux = [];

        dados.forEach(x => {
            if (x.checked) {
                aux.push({ id: x.idNf, conn: x.conn });
            }
        })

        setMarcados(aux);
    }

    const editar = (operacao, conn, id) => {
        setDadosDet({ conn, id });

    }

    useEffect(() => {
        listar();
    }, []);

    useEffect(() => {
        if (dadosDet) {
            listarCont();
        }
    }, [dadosDet]);

    useEffect(() => {
        if (marcados && marcados.length > 0) {
            enviar();
        }
    }, [marcados]);

    return (
        <>
            <Menu />
            <LoadingScreen loading={enviando} />
            <div style={{ textAlign: 'center', marginTop: 15 }}><h2>Contingência</h2></div>

            {loading && <div style={{ marginTop: 40 }}><Spinner /></div>}
            {!loading && dados && (
                <div>
                    <div style={{ marginBottom: 10, display: 'flex' }}>
                        <div style={{flex: 1}}>
                            <Search placeholder="Pesquisar" value={textoPesquisa} onChange={e => setTextoPesquisa(e.target.value)} onSearch={listar} style={{ maxWidth: 400, marginBottom: 10 }} />
                        </div>
                        <div>
                            <Button type="primary" ghost onClick={preEnviar}>Enviar</Button></div>
                        </div>
                    <div className="tabela-wrapper">
                        <table className="tabela-padrao">
                            <thead>
                                <tr>
                                    <th className="text-left"></th>
                                    <th className="text-left">Empresa</th>
                                    <th className="text-left">Data</th>
                                    <th className="text-center">Nota Fiscal</th>
                                    <th className="text-right">Valor</th>
                                    <th className="text-center">Cobertura</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {(dados || []).map((v, inx) => {
                                    return (
                                        <tr key={inx}>
                                            <td className="text-left"><Checkbox value={v.checked} onChange={e => v.checked = e.target.checked} /></td>
                                            <td className="text-left">{v.empresa}</td>
                                            <td>{moment(v.data).format('DD/MM/YYYY HH:mm:ss')}</td>
                                            <td className="text-center">{v.numero}/{v.serie}</td>
                                            <td className="text-right">{culture.format(v.valorTotal)}</td>
                                            <td className="text-center"><IconCheck ativo={!(!v.coberturaEnviNFe)} /></td>
                                            <td className="text-right">
                                                <Popover content={<Content id={v.idNf} conn={v.conn} onClick={editar} />} trigger="hover" placement="left">
                                                    <span>...</span>
                                                </Popover>
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>)}

            <Modal
                title="Contingências"
                visible={!(!retorno)}
                onCancel={() => setRetorno(null)}
                cancelText="Sair"
                footer={[<Button key="back" type="primary" ghost onClick={() => setRetorno(null)}>Sair</Button>]}
                width={1000}
            >
                {(retorno || []).map(x => {
                    return (
                        <div className='hover-container' style={{ marginBottom: 5 }}>
                            {x.sucesso ?
                                (<span><IconCheck ativo={true} /> NFe {x.nf.numero}/{x.nf.serie} enviada com sucesso! - {x.nf.empresa}</span>) :
                                (<span> <IconError ativo={true} /> NFe {x.nf.numero}/{x.nf.serie} - {x.nf.empresa} <br /> &nbsp;&nbsp;&nbsp; &nbsp;&nbsp; <Icon type="right" /> {x.msg ? x.msg : 'Erro ao enviar a NFe'}</span>)
                            }
                        </div>
                    )
                })}
            </Modal>

            <Modal
                title="Detalhes"
                visible={!(!dadosCont)}
                onCancel={() => setDadosCont(null)}
                cancelText="Sair"
                footer={[<Button key="back" type="primary" ghost onClick={() => setDadosCont(null)}>Sair</Button>]}
                width={800}
            >
                {dadosCont && (<>
                    <span>EnviNFe</span>
                    <TextArea autosize={{ minRows: 10 }} value={dadosCont.enviNFe} />
                </>)}
            </Modal>
        </>
    )
}

export default connect(null, { fetch })(Func);